import { Box, Typography, Stack } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';

import { theme } from '@app/theme';
import {
  Product,
  ProductLotteryDateSeason,
  ProductSalesType,
} from '@app/types/catalog';
import { parseDateStringToDateObj } from '@app/utils/date';

interface SalesScheduleInfoProps {
  product: Product;
}

export function SalesScheduleInfo({ product }: SalesScheduleInfoProps) {
  const rows = [
    {
      label: '販売方式',
      value: Object.values(ProductSalesType).find(
        (type) => type.key === product.customFields.salesType
      )?.label,
    },
    {
      label: '販売開始日',
      value: (
        <Typography>
          {product.customFields.lotteryDate
            ? format(
                parseDateStringToDateObj(
                  product.customFields.lotteryDate ?? ''
                ),
                product.customFields.lotteryDate?.split('/').length === 3
                  ? 'yyyy年M月d日'
                  : 'yyyy年M月'
              )
            : '-'}
          {
            Object.values(ProductLotteryDateSeason).find(
              (season) => season.key === product.customFields.lotteryDateSeason
            )?.label
          }
        </Typography>
      ),
    },
    {
      label: '販売スケジュールコメント',
      value: product.customFields.salesScheduleComment,
    },
  ];

  return (
    <Box>
      <Typography
        width="100%"
        bgcolor={theme.palette.blueAccent.main}
        color="white"
        px={2}
        height={36}
        fontWeight={600}
        borderRadius={15}
        display="flex"
        alignItems="center"
        variant="h6"
      >
        販売スケジュール
      </Typography>
      <Stack spacing={2.5} maxWidth={1040} mx="auto" mt={6} pb={7} width="100%">
        {rows.map(({ label, value }, index) => (
          <Stack
            borderBottom={1}
            borderColor="#E0E0E0"
            key={index}
            direction={{ sm: 'row', xs: 'column' }}
            spacing={1}
            pb={2.5}
          >
            <Typography
              sx={{
                color: '#718CA0',
                fontWeight: 700,
                minWidth: 200,
                whiteSpace: 'nowrap',
              }}
            >
              {label}
            </Typography>
            <Box
              sx={{
                whiteSpace: 'pre-wrap',
              }}
            >
              {value}
            </Box>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
